import Vue from 'vue';
import config from '../../config/config.json';
import { FAMILY_PREVIEW_ROUTS } from '../../constants/routes';
import NotificationService from '@/helpers/notification';

class FamilyPreviewApiService {
  constructor() {}
  async createFamilyPreview(familyPreview) {
    const response = await Vue.prototype.$http.post(
      `${config.apiUrl}${FAMILY_PREVIEW_ROUTS.BASE_URL}`,
      familyPreview
    );

    if (!!response) {
      NotificationService.success(`Family image has been published.`);
    }

    return response.data;
  }

  async getAllFamilyPreview() {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${FAMILY_PREVIEW_ROUTS.BASE_URL}`
    );

    Vue.localStorage.set('allFamilyPreview', response.data);
  }

  async getFamilyUrl(fileName) {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${FAMILY_PREVIEW_ROUTS.BASE_URL}/FamilyUrl/${fileName}`);

      return response.data;
  }
}

export default new FamilyPreviewApiService();
